import { render, staticRenderFns } from "./Pruebalibros.vue?vue&type=template&id=3a26b834&scoped=true&"
import script from "./Pruebalibros.vue?vue&type=script&lang=js&"
export * from "./Pruebalibros.vue?vue&type=script&lang=js&"
import style0 from "./Pruebalibros.vue?vue&type=style&index=0&id=3a26b834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a26b834",
  null
  
)

export default component.exports